import { render, staticRenderFns } from "./DetailTableIndicators.vue?vue&type=template&id=6998b5cc&"
import script from "./DetailTableIndicators.vue?vue&type=script&lang=js&"
export * from "./DetailTableIndicators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports